import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { I18nProvider } from "@/i18n";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { Home } from "@/pages/Home";
import { ExerciseLibrary } from "@/pages/ExerciseLibrary";
import { ExerciseDetail } from "@/pages/ExerciseDetail";
import { Pricing } from "@/pages/Pricing";
import { Favorites } from "@/pages/Favorites";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";

function App() {
  return (
    <div className="App">
      <I18nProvider>
        <BrowserRouter>
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/exercises" element={<ExerciseLibrary />} />
            <Route path="/exercise/:id" element={<ExerciseDetail />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/favorites" element={<Favorites />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
          </Routes>
          <Footer />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </I18nProvider>
    </div>
  );
}

export default App;
